module.exports = __webpack_public_path__ + "57160d3f4b8c321b2170d5396a32081e.fbx";